// Safari (iOS) is stricter than Chrome when parsing date strings: formats like
// "2026-10-05 10:30:00" or "2026-10-05T10:30:00.1234567" (.NET) return Invalid Date,
// and calling toISOString() on it throws. Normalize the string before parsing.
export function parseDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;

  const original = value.toString().trim();
  const normalized = original
    // "YYYY-MM-DD HH:mm" -> "YYYY-MM-DDTHH:mm"
    .replace(/^(\d{4}-\d{2}-\d{2})\s+(\d)/, "$1T$2")
    // fractional seconds: keep at most 3 digits
    .replace(/(\.\d{3})\d+/, "$1")
    // timezone offset "+0200" -> "+02:00"
    .replace(/([+-]\d{2})(\d{2})$/, "$1:$2");

  let date = new Date(normalized);
  if (isNaN(date)) date = new Date(original);
  return isNaN(date) ? null : date;
}
